export const GENERATE_DESCRIPTION_PROMPT =
  '请根据本笔记本的标题和大纲，生成一段 50-100 字的描述，概括该笔记本的核心内容和学习要点。只输出描述文字，不要其他说明。';
